import { gql } from '@apollo/client';

export type NextGenMembershipInput = {
  organization: string;
  roles: string[];
};

export type MembershipsV3Type = {
  organization: string;
  role: string;
};

export interface CreateAdminUserInput {
  email: string;
  firstName: string;
  lastName: string;
  password: string;
  roles: string[];
  tenant?: string;
  memberships?: NextGenMembershipInput[];
  membershipsV3?: MembershipsV3Type[];
}

export interface PutUser {
  email: string;
  firstName: string;
  lastName: string;
  password?: string;
  roles: string[];
  memberships?: NextGenMembershipInput[];
  membershipsV3?: MembershipsV3Type[];
  enabled: boolean;
  onboarded: boolean;
  username: string;
  uuid?: string;
}

export interface CreateAdminResponse {
  createAdminUser?: {
    uuid: string;
  };
  createUser?: any;
}

export const CREATE_ADMIN_USER = gql`
  mutation createAdminUser($input: CreateAdminUserInput!) {
    createAdminUser(input: $input) {
      uuid
    }
  }
`;

export const CREATE_ADMIN_BY_TENANT = gql`
  mutation createUser($input: putUser!) {
    createUser(input: $input) {
      uuid
    }
  }
`;
